module.exports = __webpack_public_path__ + "static/media/flag-mt.97960572.webp";